import { importantNoteColumns } from 'constants/WorkingModePathwaysConstants'

import { renderSegments } from './renderSegments'

export const ImportantNotePanel = () => (
  <div className="pathway-important-note">
    <p className="subtitle-xl w-full">Important note</p>
    <div className="flex gap-6 items-start w-full">
      {importantNoteColumns.map((column, index) => (
        <div key={index} className="flex flex-col gap-2 items-start flex-1 min-w-0">
          {column.paragraphs.map((paragraph, paragraphIndex) => (
            <p key={paragraphIndex} className="body-s w-full">
              {renderSegments(paragraph)}
            </p>
          ))}
        </div>
      ))}
    </div>
  </div>
)
